import { defaultTheme, type RaThemeOptions } from 'react-admin';
import { deepmerge } from '@mui/utils';
import { colors } from '@mui/material';

const myTheme: RaThemeOptions = deepmerge(defaultTheme, {
  palette: {
    mode: 'light',
    primary: {
      main: '#31006F',
      light: '#5a2d91',
      dark: '#1e0041',
    },
    secondary: {
      main: '#9C0059',
      light: '#c13876',
      dark: '#6b003d',
    },
    background: {
      default: '#f7f5fb',
      paper: '#ffffff',
    },
    info: {
      main: '#E86D1F',
      light: '#ff9e4d',
      dark: '#b54400',
    },
    error: colors?.red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: ['Inter', '-apple-system', 'sans-serif'].join(','),
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined' as const,
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'outlined' as const,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 12,
          color: '#b54400',
          fontWeight: 600,
          fontSize: '0.875rem',
          padding: '8px 16px',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          boxShadow: '0 2px 4px rgba(181, 68, 0, 0.1)',
          border: '1px solid rgba(181, 68, 0, 0.2)',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(10px)',
          '&:hover': {
            // color: '#ffffff',
            color: 'black',
            backgroundColor: '#b54400',
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(181, 68, 0, 0.3)',
            border: '1px solid #b54400',
          },
          '&:active': {
            transform: 'translateY(0px)',
            boxShadow: '0 2px 6px rgba(181, 68, 0, 0.2)',
          },
          '&:focus': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(181, 68, 0, 0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(49, 0, 111, 0.08)',
          border: '1px solid rgba(49, 0, 111, 0.05)',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            // Keep only subtle background for selected state globally; don't force text/icon colors
            backgroundColor: 'rgba(0, 0, 0, 0.06)',
            borderLeft: 'none',
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export default myTheme;
